export default "__VITE_ASSET__Hr76NC6w__"